document.addEventListener("DOMContentLoaded", function() {
  let tags = window?.BSS_B2B?.shopData?.customer?.tags || [];
  if (typeof tags === "string") {
    tags = tags.split(",").map(t => t.trim().toLowerCase());
  } else {
    tags = tags.map(t => t.trim().toLowerCase());
  }

  const wholesaleTags = ["wholesale", "wholesale_10", "wholesale_15"];

  const isWholesale = tags.some(tag => wholesaleTags.includes(tag));

  if (
    isWholesale &&
    window.location.pathname === "/cart" &&
    !window.location.search.includes("view=wholesale")
  ) {
    window.location.replace("/cart?view=wholesale");
  }
});
